
export default function Contact() {
  return (
    <section id="contato" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Entre em <span className="text-red-600">Contato</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Estamos sempre prontos para atender você da melhor forma possível
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Contact Info */}
            <div className="space-y-8">
              <div className="bg-white rounded-3xl shadow-2xl p-8 border-2 border-red-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-8">Fale Conosco</h3>
                
                <div className="space-y-6">
                  <div className="flex items-center p-4 bg-red-50 rounded-2xl">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mr-6">
                      <i className="ri-phone-fill text-white text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">Telefone</h4>
                      <p className="text-gray-700 text-lg">(34) 99964-5580</p>
                    </div>
                  </div>

                  <div className="flex items-center p-4 bg-green-50 rounded-2xl">
                    <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mr-6">
                      <i className="ri-whatsapp-fill text-white text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">WhatsApp</h4>
                      <p className="text-gray-700 text-lg">(34) 99964-5580</p>
                    </div>
                  </div>

                  <div className="flex items-center p-4 bg-blue-50 rounded-2xl">
                    <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-6">
                      <i className="ri-map-pin-fill text-white text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">Endereço</h4>
                      <p className="text-gray-700 text-lg">Av. Marginal José Simeão de Queiroz, 141</p>
                      <p className="text-gray-700">Iturama - MG, CEP: 38.280-000</p>
                    </div>
                  </div>

                  <div className="flex items-center p-4 bg-red-50 rounded-2xl">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mr-6">
                      <i className="ri-time-fill text-white text-2xl"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 text-lg">Horário</h4>
                      <p className="text-gray-700 text-lg">Das 8h às 18h</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Action Buttons */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <a 
                  href="https://wa.me/5534999645580?text=Olá! Gostaria de fazer um pedido de gás de cozinha."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 text-white p-6 rounded-2xl text-center hover:bg-green-700 transition-all transform hover:scale-105 cursor-pointer shadow-xl"
                >
                  <i className="ri-whatsapp-fill text-3xl mb-2 block"></i>
                  <span className="font-bold text-lg">Chamar no WhatsApp</span>
                </a>

                <a 
                  href="tel:+5534999645580"
                  className="bg-blue-600 text-white p-6 rounded-2xl text-center hover:bg-blue-700 transition-all transform hover:scale-105 cursor-pointer shadow-xl"
                >
                  <i className="ri-phone-fill text-3xl mb-2 block"></i>
                  <span className="font-bold text-lg">Ligar Agora</span>
                </a>
              </div>
            </div>

            {/* Map or Additional Info */}
            <div className="bg-white rounded-3xl shadow-2xl p-8 border-2 border-blue-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Nossa Localização</h3>
              
              <div className="aspect-video bg-gray-100 rounded-2xl mb-8 overflow-hidden" style={{ aspectRatio: '16/12' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29234.567890123456!2d-50.1234567!3d-20.0567890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c8c9c9c9c9c9c9%3A0x1234567890abcdef!2sIturama%2C%20MG!5e0!3m2!1spt!2sbr!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localização Iturama"
                ></iframe>
              </div>

              <div className="text-center">
                <button 
                  onClick={() => document.getElementById('pedido')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-red-600 text-white px-8 py-4 rounded-2xl font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
                >
                  <i className="ri-shopping-cart-fill mr-2"></i>
                  FAZER PEDIDO AGORA
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
